const Step1Url = "https://eootd50yfy38.m.pipedream.net";
const Step2Url = "https://eorl0l9e28nf1ae.m.pipedream.net";
const Step3Url = "https://eoiqbugu3o545ki.m.pipedream.net";
const Step4Url = "https://eoh3rhx2us873m4.m.pipedream.net";
const Step5Url = "https://eok1txbrrnqallj.m.pipedream.net";
const Step6Url = "https://eogd95vhxg0vud8.m.pipedream.net";
const Step7Url = "https://eorzro916og2nds.m.pipedream.net";
const Step8Url = "";
const Step9Url = "";
const StepRecorder = "https://eo9sj0vejbwhxhb.m.pipedream.net";

let $form;
let idPoliza, idQr, Uuid, datosVendedor, toIndex;
let deshabilitados = [];

document.addEventListener('DOMContentLoaded', function () {
  CF.ready(function () {
    $form = document.querySelector('form[data-cf-form="kntzyK"]');

    document.getElementById('verificarVendedor').addEventListener('click', function () {
      $form.cfForm.setFieldValue('verificando', true);
      $form.cfForm.setFieldValue('verificando_persona', true);
      const data = {
        usuario: $form.cfForm.getFieldValue('usuario'),
        pin: $form.cfForm.getFieldValue('pin')
      }

      let requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: "follow"
      };

      fetch(Step6Url, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          if (result.mensaje === 'Verificado') {
            $form.cfForm.setFieldValue('vendedor_verificado', true);
            $form.cfForm.setFieldValue('verificando', false);
            Uuid = result.uudid;
            datosVendedor = result.datos;
          } else {
            $form.cfForm.setFieldValue('verificando', false);
          }
        })
        .catch((error) => {
          $form.cfForm.setFieldValue('verificando', false);
        });

      requestOptions = {
        method: "POST",
        body: JSON.stringify(getFullData()),
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: "follow"
      };

      fetch(Step7Url, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          $form.cfForm.setFieldValue('persona_verificada', true);
          $form.cfForm.setFieldValue('verificando_persona', false);
          $form.cfForm.setFieldValue('verificar_persona_end', true);
          if (result.mensaje === 'Verificado') {
            //$form.cfForm.setFieldValue('usuario_existe', true);
            // $form.cfForm.setFieldValue('primer_nombre', result.data[0]);
            setDatos('primer_nombre', result.data[0], "true");
            setDatos('segundo_nombre', result.data[1], "true");
            setDatos('apellido_paterno', result.data[2], "true");
            setDatos('apellido_materno', result.data[3], "true");
            setDatos('genero', result.data[13], "true");
            setDatos('complemento', result.data[8], "true");
            setDatos('phone', result.data[4], "false");
            setDatos('correo', result.data[5], "false");
            setDatos('estado_civil', result.data[12], "false");
            setDatos('profesion', result.data[14], "false");
            setDatos('ocupacion', result.data[15], "false");
            setDatos('tipo_documento', result.data[6], "false");
            setDatos('nacionalidad', result.data[9], "false");
            setDatos('pais_nacimiento', result.data[10], "false");
            let nombreC = [result.data[0], result.data[1], result.data[2], result.data[3]].join(' ').split(/\s+/).filter(Boolean).join(' ');
            $form.cfForm.setFieldValue('persona_encontrada', `Registro de ${nombreC} encontrado`);
          } else {
            //$form.cfForm.setFieldValue('usuario_existe', false);
            $form.cfForm.setFieldValue('persona_encontrada', "No se encontró información del cliente. Por favor, llenar los campos en blanco");
          }
        })
        .catch((error) => {
          $form.cfForm.setFieldValue('verificar_persona_end', true);
          $form.cfForm.setFieldValue('persona_verificada', true);
          //$form.cfForm.setFieldValue('usuario_existe', false);
          $form.cfForm.setFieldValue('verificando_persona', false);
          $form.cfForm.setFieldValue('persona_encontrada', "No se encontró información del cliente. Por favor, llenar los campos en blanco");
        });
    });

    $form.addEventListener('cf:field_changed', function (event) {
      var fieldId = event.detail.fieldId;
      var columnKey = event.detail.columnKey;
      var value = event.detail.value;

      // console.log(`${columnKey} - ${value}`);

      if (columnKey === 'anualidad') {
        try {
          let resultado = parseInt(value) * parseInt($form.cfForm.getFieldValue('prima'));
          $form.cfForm.setFieldValue('total', `${resultado}`);
        } catch (error) {

        }
      }
      if (columnKey === 'porcentaje') {
        try {
          let sum = 0;
          for (const item of $form.cfForm.getFieldValue('beneficiarios')) {
            sum += parseInt(item.porcentaje);
          }
          $form.cfForm.setFieldValue('porcentaje_total', sum);
        } catch (error) {

        }
      }
      // if (columnKey === 'opciones_pago') {
      //   if (value === '0') {
      //     $form.cfForm.setFieldValue('obtener_qr_activo', true);
      //     $form.cfForm.setFieldValue('cajas_activo', false);
      //   } else {
      //     $form.cfForm.setFieldValue('obtener_qr_activo', false);
      //     $form.cfForm.setFieldValue('cajas_activo', true);
      //   }
      // }
    });

    $form.addEventListener('cf:step_changed', function (event) {
      let formId = event.detail.formId;
      let fromIndex = event.detail.fromIndex;
      toIndex = event.detail.toIndex;

      if (fromIndex === 0 && toIndex === 1) {
        sendData();
      }
      if (fromIndex === 1 && toIndex === 2) {
        IniciarDirecciones();
        deshabilitados.forEach(item => {
          document.querySelector(`.css-${item}`).classList.add('deshabilitado');
        });
        sendData();
      }
      if (fromIndex === 2 && toIndex === 3) {
        sendData();
      }
      if (fromIndex === 3 && toIndex === 4) {
        conteoOtp();
        sendData();
        let data = getFullData();

        const requestOptions = {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: "follow"
        };

        fetch(Step1Url, requestOptions)
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));

        document.getElementById('verificarOTP').addEventListener('click', function () {
          $form.cfForm.setFieldValue('verificar_otp', false);
          $form.cfForm.setFieldValue('error_verificar_otp', false);
          const data = getFullData();

          const requestOptions = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };

          fetch(Step2Url, requestOptions)
            .then((response) => {
              return response.json();
            })
            .then((result) => {
              $form.cfForm.setFieldValue('verificar_otp', true);
              if (result.respuesta === 'Verificado') {
                $form.cfForm.setFieldValue('otp_verificado', true);
                $form.cfForm.setFieldValue('error_verificar_otp', false);
              } else {
                $form.cfForm.setFieldValue('error_verificar_otp', true);
              }
            })
            .catch((error) => {
              $form.cfForm.setFieldValue('error_verificar_otp', true);
              $form.cfForm.setFieldValue('verificar_otp', true);
            });
        });
      }
      if (fromIndex === 4 && toIndex === 5) {
        $form.cfForm.setFieldValue('stop', true);
        $form.cfForm.setFieldValue('generando_qr', true);
        $form.cfForm.setFieldValue('opciones_activo', false);
        $form.cfForm.setFieldValue('obtener_qr_activo', false);
        let data = getFullData();
        const requestOptions = {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: "follow"
        };
        fetch(Step3Url, requestOptions)
          .then((response) => response.json())
          .then(data => {
            $form.cfForm.setFieldValue('generando_qr', false);
            if (data.message === "Gracias") {
              $form.cfForm.setFieldValue('qr_activo', true);
              $form.cfForm.setFieldValue('ya_he_pagado', true);
              idQr = data.idQr;
              idPoliza = data.idPoliza;
              let base64imageElement = document.getElementById('base64image');
              if (base64imageElement) {
                base64imageElement.src = 'data:image/png;base64,' + data.image;
              } else {
                $form.cfForm.setFieldValue('error_desconocido', true);
              }
            } else if (data.message === "Error PeP") {
              $form.cfForm.setFieldValue('error_pep', true);
            }
            else {
              $form.cfForm.setFieldValue('error_desconocido', true);
            }
          })
          .catch(error => {
            console.log('Error fetching the image:', error);
            $form.cfForm.setFieldValue('error_desconocido', true);
            $form.cfForm.setFieldValue('generando_qr', false);
          });
        // $form.cfForm.setFieldValue('opciones_activo', true);
        // if ($form.cfForm.getFieldValue('anualidad') === "1") {
        //   $form.cfForm.setFieldValue('obtener_qr_activo', true);
        // } else {
        //   $form.cfForm.setFieldValue('cajas_activo', true);
        // }

        // document.getElementById('obtenerQr').addEventListener('click', function () {
        //   $form.cfForm.setFieldValue('generando_qr', true);
        //   $form.cfForm.setFieldValue('opciones_activo', false);
        //   $form.cfForm.setFieldValue('obtener_qr_activo', false);
        //   let data = getFullData();
        //   const requestOptions = {
        //     method: "POST",
        //     body: JSON.stringify(data),
        //     headers: {
        //       'Content-Type': 'application/json'
        //     },
        //     redirect: "follow"
        //   };
        //   fetch(Step3Url, requestOptions)
        //     .then((response) => response.json())
        //     .then(data => {
        //       $form.cfForm.setFieldValue('generando_qr', false);
        //       idQr = data.idQr;
        //       idPoliza = data.idPoliza;
        //       let base64imageElement = document.getElementById('base64image');
        //       if (base64imageElement) {
        //         base64imageElement.src = 'data:image/png;base64,' + data.image;
        //       } else {
        //         console.error('Element base64image not found');
        //       }
        //       $form.cfForm.setFieldValue('qr_activo', true);
        //     })
        //     .catch(error => {
        //       console.log('Error fetching the image:', error);
        //     });
        // });

        document.getElementById('descargar-QR').addEventListener('click', function () {
          const imgElement = document.getElementById('base64image');
          const imgBase64 = imgElement.src;
          const link = document.createElement('a');
          link.href = imgBase64;
          link.download = 'PagoSeguroQR.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });

        document.getElementById('yahepagado').addEventListener('click', function () {
          $form.cfForm.setFieldValue('verificando_pago', true);
          $form.cfForm.setFieldValue('error_verificar_pago', false);
          $form.cfForm.setFieldValue('ya_he_pagado', false);
          data = getFullData();
          const requestOptions = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };

          fetch(Step4Url, requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result && result.mensaje) {
                if (result.mensaje === "No pagado") {
                  $form.cfForm.setFieldValue('error_verificar_pago', true);
                  $form.cfForm.setFieldValue('verificando_pago', false);
                  $form.cfForm.setFieldValue('ya_he_pagado', true);
                }
                else if (result.mensaje === 'Pagado') {
                  $form.cfForm.setFieldValue('qr_activo', false);
                  $form.cfForm.setFieldValue('verificando_pago', false);
                  $form.cfForm.setFieldValue('error_verificar_pago', false);
                  $form.cfForm.setFieldValue('pago_exitoso', true);
                  $form.cfForm.setFieldValue('cajas_activo', false);
                  data = getFullData();
                  const newOptions = {
                    method: "POST",
                    body: JSON.stringify(result),
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    redirect: "follow"
                  };
                  fetch(Step5Url, newOptions)
                    .then((response) => response.json())
                    .then((result) => {
                      if (isValidUrl(result.url)) {
                        url = result.url
                        localStorage.removeItem('cf:guest_data');
                        window.location.href = url;
                        console.log(url);
                      } else {
                        console.error('Error', result);
                      }
                    })
                    .catch((error) => console.error(error));
                }
              }
              else {
                $form.cfForm.setFieldValue('error_verificar_pago', true);
                $form.cfForm.setFieldValue('verificando_pago', false);
                $form.cfForm.setFieldValue('qr_activo', true);
                $form.cfForm.setFieldValue('ya_he_pagado', true);
              }
            })
            .catch(error => {
              $form.cfForm.setFieldValue('error_verificar_pago', true);
              $form.cfForm.setFieldValue('verificando_pago', false);
              $form.cfForm.setFieldValue('qr_activo', true);
              $form.cfForm.setFieldValue('ya_he_pagado', true);
            }
            );

        });

        document.getElementById('compraCajas').addEventListener('click', function () {
          $form.cfForm.setFieldValue('verificando_pago', true);
          $form.cfForm.setFieldValue('error_verificar_pago', false);
          $form.cfForm.setFieldValue('cajas_activo', false);
          data = getFullData();
          let requestOptions = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };

          fetch(Step9Url, requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result && result.mensaje) {
                if (result.mensaje === "No pagado") {
                  $form.cfForm.setFieldValue('error_verificar_pago', true);
                  $form.cfForm.setFieldValue('verificando_pago', false);
                }
                else if (result.mensaje === 'Pagado') {
                  $form.cfForm.setFieldValue('obtener_qr_activo', false);
                  $form.cfForm.setFieldValue('qr_activo', false);
                  $form.cfForm.setFieldValue('verificando_pago', false);
                  $form.cfForm.setFieldValue('error_verificar_pago', false);
                  $form.cfForm.setFieldValue('cajas_activo', false);
                  $form.cfForm.setFieldValue('pago_exitoso', true);
                  const newOptions = {
                    method: "POST",
                    body: JSON.stringify(result),
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    redirect: "follow"
                  };
                  fetch(Step5Url, newOptions)
                    .then((response) => response.json())
                    .then((result) => {
                      if (isValidUrl(result.url)) {
                        url = result.url
                        localStorage.removeItem('cf:guest_data');
                        window.location.href = url;
                        console.log(url);
                      } else {
                        console.error('Error', result);
                      }
                    })
                    .catch((error) => console.error(error));
                }
              }
              else {
                $form.cfForm.setFieldValue('error_verificar_pago', true);
                $form.cfForm.setFieldValue('verificando_pago', false);
                $form.cfForm.setFieldValue('cajas_activo', true);
              }
            })
            .catch(error => {
              $form.cfForm.setFieldValue('error_verificar_pago', true);
              $form.cfForm.setFieldValue('verificando_pago', false);
              $form.cfForm.setFieldValue('cajas_activo', true);
            }
            );
        });
      }
    });
  });
});

function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

function getFullData() {
  return {
    "usuario": $form.cfForm.getFieldValue('usuario').trim(),
    "pin": $form.cfForm.getFieldValue('pin').trim(),
    "nro_de_documento": $form.cfForm.getFieldValue('nro_de_documento').trim(),
    "fecha_nacimiento": $form.cfForm.getFieldValue('fecha_nacimiento'),
    "primer_nombre": $form.cfForm.getFieldValue('primer_nombre').trim(),
    "segundo_nombre": $form.cfForm.getFieldValue('segundo_nombre').trim(),
    "apellido_paterno": $form.cfForm.getFieldValue('apellido_paterno').trim(),
    "apellido_materno": $form.cfForm.getFieldValue('apellido_materno').trim(),
    "correo": $form.cfForm.getFieldValue('correo').trim(),
    "tipo_documento": $form.cfForm.getFieldValue('tipo_documento'),
    "complemento": $form.cfForm.getFieldValue('complemento').trim(),
    "extension": $form.cfForm.getFieldValue('extension'),
    "nacionalidad": $form.cfForm.getFieldValue('nacionalidad'),
    "pais_nacimiento": $form.cfForm.getFieldValue('pais_nacimiento'),
    "phone": $form.cfForm.getFieldValue('phone'),
    "estado_civil": $form.cfForm.getFieldValue('estado_civil'),
    "genero": $form.cfForm.getFieldValue('genero'),
    "profesion": $form.cfForm.getFieldValue('profesion'),
    "ocupacion": $form.cfForm.getFieldValue('ocupacion').trim(),
    "pais_viviendo": $form.cfForm.getFieldValue('pais_viviendo'),
    "departamento_viviendo": $form.cfForm.getFieldValue('aux_departamento'),
    "ciudad_viviendo": $form.cfForm.getFieldValue('aux_ciudad'),
    "zona": $form.cfForm.getFieldValue('zona').trim(),
    "calle": $form.cfForm.getFieldValue('calle').trim(),
    "numero_casa": $form.cfForm.getFieldValue('numero_casa').trim(),
    "barrio": $form.cfForm.getFieldValue('aux_barrio'),
    "referencias": $form.cfForm.getFieldValue('referencias').trim(),
    "acuerdo_final": $form.cfForm.getFieldValue('acuerdo_final'),
    "beneficiarios": $form.cfForm.getFieldValue('beneficiarios'),
    "otp": $form.cfForm.getFieldValue('otp'),
    "anualidad": $form.cfForm.getFieldValue('anualidad'),
    "prima": $form.cfForm.getFieldValue('prima'),
    "total": $form.cfForm.getFieldValue('total'),
    "numero_factura": $form.cfForm.getFieldValue('numero_factura').trim(),
    "anualidad": $form.cfForm.getFieldValue('anualidad'),
    "ciudadano_americano": $form.cfForm.getFieldValue('ciudadano_americano_1'),
    idPoliza,
    idQr,
    Uuid,
    datosVendedor,
    toIndex
  }
}

function sendData() {
  let data = getFullData();

  const requestOptions = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: "follow"
  };

  fetch(StepRecorder, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}

function setDatos(name, arg, o) {
  $form.cfForm.setFieldValue(name, arg);
  if (o === "true") {
    if (arg) {
      if (arg != "") {
        deshabilitados.push(name);
      }
    }
  }
}

function conteoOtp() {
  let conteoElemento = document.getElementById('conteo1');
  let botonElemento = document.getElementById('boton1');
  let tiempoConteo = 59;
  let intervaloId = setInterval(function () {
    if (tiempoConteo >= 0) {
      conteoElemento.innerText = `${tiempoConteo} seg(s) para poder enviar OTP nuevamente`;
      tiempoConteo--;
    } else {
      clearInterval(intervaloId);
      botonElemento.style.display = 'inline-flex';
      conteoElemento.style.display = 'none';
      botonElemento.addEventListener('click', function () {
        let data = getFullData();

        const requestOptions = {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: "follow"
        };

        fetch(Step1Url, requestOptions)
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));

        botonElemento.style.display = 'none';
        conteoOtp2();
      });
    }
  }, 1000);
}

function conteoOtp2() {
  let conteoElemento = document.getElementById('conteo2');
  let botonElemento = document.getElementById('boton2');
  conteoElemento.style.display = 'inline-flex';
  let tiempoConteo = 59;
  let intervaloId = setInterval(function () {
    if (tiempoConteo >= 0) {
      conteoElemento.innerText = `${tiempoConteo} seg(s) para poder enviar OTP nuevamente`;
      tiempoConteo--;
    } else {
      clearInterval(intervaloId);
      botonElemento.style.display = 'inline-flex';
      conteoElemento.style.display = 'none';
      botonElemento.addEventListener('click', function () {
        let data = getFullData();

        const requestOptions = {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: "follow"
        };

        fetch(Step1Url, requestOptions)
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));

        botonElemento.style.display = 'none';
      });
    }
  }, 1000);
}

function IniciarDirecciones() {
  document.getElementById('drop_down_departamentos').addEventListener('change', function (event) {
    validarSeleccionDepartamentos(event.target);
  });
  document.getElementById('drop_down_cuidades').addEventListener('change', function (event) {
    validarSeleccionCiudades(event.target);
  });
  document.getElementById('drop_down_barrios').addEventListener('change', function (event) {
    validarSeleccionBarrios(event.target);
  });
  cargarDepartamentos();
  cargarCiudades();
  cargarBarrios();
}

function cargarDepartamentos() {
  document.getElementById('drop_down_departamentos').parentElement.parentElement.style.width = '100%'
  const datalist = document.getElementById('lista-departamentos');

  collection_departamentos.forEach(departamento => {
    const option = document.createElement('option');
    option.value = departamento.nombre;
    option.setAttribute('data-cod', departamento.cod);
    option.setAttribute('data-id', departamento.id);

    datalist.appendChild(option);
  });
}

function cargarCiudades() {
  document.getElementById('drop_down_cuidades').parentElement.parentElement.style.width = '100%'
  const datalist = document.getElementById('lista-ciudades');

  collection_ciudades.forEach(ciudad => {
    const option = document.createElement('option');
    option.value = ciudad.nombre;
    option.setAttribute('data-cod', ciudad.cod);
    option.setAttribute('data-id', ciudad.id);

    datalist.appendChild(option);
  });
}

function cargarBarrios() {
  document.getElementById('drop_down_barrios').parentElement.parentElement.style.width = '100%'
  const datalist = document.getElementById('lista-barrios');

  collection_barrios.forEach(barrio => {
    const option = document.createElement('option');
    option.value = barrio.nombre;
    option.setAttribute('data-cod', barrio.cod);
    option.setAttribute('data-id', barrio.id);

    datalist.appendChild(option);
  });
}

function validarSeleccionDepartamentos(inputElement) {
  const inputValue = inputElement.value;
  const datalist = document.getElementById(inputElement.getAttribute('list'));
  const alerta = document.getElementById('alerta_departamentos');
  let opcionSeleccionada = null;
  for (const option of datalist.options) {
    if (option.value === inputValue) {
      opcionSeleccionada = option;
      break;
    }
  }
  if (!opcionSeleccionada && inputValue !== "") {
    inputElement.value = "";
    document.getElementById('drop_down_cuidades').value = "";
    document.getElementById('drop_down_barrios').value = "";
    $form.cfForm.setFieldValue('aux_departamento', "");
    $form.cfForm.setFieldValue('aux_ciudad', "");
    $form.cfForm.setFieldValue('aux_barrio', "");
    alerta.textContent = "⚠️ Por favor, selecciona un departamento de la lista de sugerencias.";

  } else {
    alerta.textContent = "";

    if (opcionSeleccionada) {
      const codDepartamento = opcionSeleccionada.getAttribute('data-cod');
      const idDepartamento = opcionSeleccionada.getAttribute('data-id');

      let listaFiltrada = collection_ciudades.filter(x => {
        return x.id == idDepartamento;
      })
      let datalist = document.getElementById('lista-ciudades');
      datalist.innerHTML = '';
      listaFiltrada.forEach(ciudad => {
        const option = document.createElement('option');
        option.value = ciudad.nombre;
        option.setAttribute('data-cod', ciudad.cod);
        option.setAttribute('data-id', ciudad.id);
        datalist.appendChild(option);
      });

      listaFiltrada = collection_barrios.filter(x => {
        return x.id == idDepartamento;
      })
      datalist = document.getElementById('lista-barrios');
      datalist.innerHTML = '';
      listaFiltrada.forEach(barrio => {
        const option = document.createElement('option');
        option.value = barrio.nombre;
        option.setAttribute('data-cod', barrio.cod);
        option.setAttribute('data-id', barrio.id);
        datalist.appendChild(option);
      });

      document.getElementById('drop_down_cuidades').value = "";
      document.getElementById('drop_down_barrios').value = "";

      $form.cfForm.setFieldValue('aux_departamento', codDepartamento);
      $form.cfForm.setFieldValue('aux_ciudad', "");
      $form.cfForm.setFieldValue('aux_barrio', "");
    }
  }
}

function validarSeleccionCiudades(inputElement) {
  const inputValue = inputElement.value;
  const datalist = document.getElementById(inputElement.getAttribute('list'));
  const alerta = document.getElementById('alerta_ciudades');
  let opcionSeleccionada = null;
  for (const option of datalist.options) {
    if (option.value === inputValue) {
      opcionSeleccionada = option;
      break;
    }
  }
  if (!opcionSeleccionada && inputValue !== "") {
    inputElement.value = "";
    $form.cfForm.setFieldValue('aux_ciudad', "");
    alerta.textContent = "⚠️ Por favor, selecciona una ciudad de la lista de sugerencias.";

  } else {
    alerta.textContent = "";

    if (opcionSeleccionada) {
      const codCiudad = opcionSeleccionada.getAttribute('data-cod');
      const idCiudad = opcionSeleccionada.getAttribute('data-id');
      $form.cfForm.setFieldValue('aux_ciudad', codCiudad);
    }
  }
}

function validarSeleccionBarrios(inputElement) {
  const inputValue = inputElement.value;
  const datalist = document.getElementById(inputElement.getAttribute('list'));
  const alerta = document.getElementById('alerta_barrios');
  let opcionSeleccionada = null;
  for (const option of datalist.options) {
    if (option.value === inputValue) {
      opcionSeleccionada = option;
      break;
    }
  }
  if (!opcionSeleccionada && inputValue !== "") {
    inputElement.value = "";
    $form.cfForm.setFieldValue('aux_barrio', "");
    alerta.textContent = "⚠️ Por favor, selecciona un barrio de la lista de sugerencias.";

  } else {
    alerta.textContent = "";

    if (opcionSeleccionada) {
      const codBarrio = opcionSeleccionada.getAttribute('data-cod');
      const idBarrio = opcionSeleccionada.getAttribute('data-id');
      $form.cfForm.setFieldValue('aux_barrio', codBarrio);
    }
  }
}